import { gql } from '@/apollo/gql';

export const groupMemberFragment = gql(`
  fragment GroupMemberFragment2 on GroupMember {
    accountId
    reader
    admin
    account {
      rowId
      id
      entity {
        ... on Account_User {
          rowId
        }
        ... on Account_Bot {
          rowId
        }
        ... on Account_Team {
          rowId
          accountId
          members {
            nodes {
              userId
            }
          }
          bots {
            nodes {
              rowId
            }
          }
        }
        ... on Account_Organization {
          rowId
          accountId
          members {
            nodes {
              userId
            }
          }
          bots {
            nodes {
              rowId
            }
          }
          teams {
            nodes {
              rowId
            }
          }
        }
      }
    }
  }
`);

export const workflowGroups = gql(`
  fragment WorkflowGroupsFragment on Workflow {
    rowId
    id
    name
    description
    canUpdate
    groups(
      orderBy: $orderBy
      first: $first
      after: $cursor
      filter: $filter
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        rowId
        id
        createdAt
        updatedAt
        label
        name
        avatar
        members {
          totalCount
          nodes {
            ...GroupMemberFragment2
          }
        }
      }
    }
    nonFilteredGroups: groups {
      totalCount
    }
  }
`);

export const WORKFLOW_GROUPS_QUERY = gql(`
  query workflowGroupsQuery(
    $workflowRowId: BigInt!
    $orderBy: [GroupsOrderBy!]
    $first: Int
    $cursor: Cursor
    $filter: GroupFilter
  ) {
    workflowByRowId(rowId: $workflowRowId) {
      ...WorkflowGroupsFragment
    }
  }
`);

export const ADD_GROUP_MUTATION = gql(`
  mutation addGroupMutation(
    $workflowRowId: BigInt!
    $name: String!
    $key: String!
    $orderBy: [GroupsOrderBy!]
    $first: Int
    $cursor: Cursor
    $filter: GroupFilter
  ) {
    createGroup(
      input: { group: { workflowId: $workflowRowId, label: $key, name: $name } }
    ) {
      group {
        rowId
      }
      workflow {
        ...WorkflowGroupsFragment
      }
    }
  }
`);
